/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { EGTMBasketSectionType } from '@modules/analytics/GoogleTagManager/GTMOperations/GTMBasketOperations';
import {
    API_REPORTS_SUBSCRIBER_EDIT_BASKET_LIST,
    API_REPORTS_SUBSCRIBER_EDIT_FILTER_AND_SORT,
    API_REPORTS_SUBSCRIBER_EDIT_LIST,
    API_REPORTS_SUBSCRIBER_EDIT_META,
    REPORTS_SUBSCRIBER_EDIT_BASKET,
} from '@modules/app/Api';
import { ELogBusinessEventName, ELogBusinessEventType } from '@modules/logging';
import { ITableInitialise } from '@modules/table/types';

import { API_SUBSCRIBER_TABLE_LABEL } from '../PageSubscriberMobile/constants';
import { IReportsSubscriberTable } from './types';

export const TABLE_FILTER_AVAILABLE_NAMES: Array<keyof IReportsSubscriberTable> = [
    'accessName',
    'account',
    'accountName',
    'assistantCampaignsCount',
    'balance',
    'cityNumber',
    'contractNumber',
    'coordinatorCampaignsCount',
    'dcRules',
    'icc',
    'inn',
    'kpp',
    'labels',
    'loyaltyStatus',
    'msisdn',
    'name',
    'numberType',
    'persDataLockDate',
    'persDataStatusName',
    'position',
    'ratePlan',
    'status',
    'subdivisionKpp',
    'subdivisionName',
    'zone',
];

export const REPORTS_SUBSCRIBERS_TABLE_CONFIG: ITableInitialise = {
    meta: {
        url: API_REPORTS_SUBSCRIBER_EDIT_META,
    },
    list: {
        url: API_REPORTS_SUBSCRIBER_EDIT_LIST,
        log: {
            eventName: ELogBusinessEventName.B2B_MOBILE_SUBSCRIBERS,
            type: ELogBusinessEventType.common,
        },
    },
    filterAndSort: {
        url: API_REPORTS_SUBSCRIBER_EDIT_FILTER_AND_SORT,
    },
    basket: {
        checkbox: REPORTS_SUBSCRIBER_EDIT_BASKET,
        list: API_REPORTS_SUBSCRIBER_EDIT_BASKET_LIST,
        gtm: {
            loadList: EGTMBasketSectionType.MOBILE,
        },
    },
    labels: {
        url: API_SUBSCRIBER_TABLE_LABEL,
        fieldName: 'labels',
    },
};
